import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import artMark from "../assets/nav_art.png";
import { pageColors } from "../mock";
import { useAuth } from "../context/AuthContext";
import { Palette, ArrowRight } from "lucide-react";
import { ArtShowRequest } from "../components/ArtShowRequest";

const API = process.env.REACT_APP_BACKEND_URL;

const Art = () => {
  const { current } = useAuth();
  const [approved, setApproved] = useState([]);

  useEffect(() => {
    document.title = "TMM|ART";
    (async () => {
      try {
        const r = await fetch(`${API}/api/applications/approved/art`);
        const d = await r.json();
        setApproved(d.applications || []);
      } catch {
        /* ignore */
      }
    })();
  }, []);

  const canApply = current && current.status === "approved";

  return (
    <>
      <Header hoverColor={pageColors.art} compact={false} />
      <div className="page-mark-hero">
        <img src={artMark} alt="Art" className="page-mark-hero-img" />
      </div>
      <div className="art-page">
        <div className="art-intro">
          <p className="art-eyebrow">The first Monde Mania Art Show is on the horizon.</p>
          <p className="art-lead">
            If you paint, print, sculpt, or otherwise make things you'd hang on
            a wall — put your name in the hat. We're curating slowly.
          </p>
          {canApply ? (
            <Link to="/apply/art" className="btn-solid btn-huge" data-testid="art-apply-btn">
              <Palette size={18} /> Apply for the Art Show <ArrowRight size={16} />
            </Link>
          ) : (
            <div className="music-apply-gate">
              Approved members can apply. <Link to="/members">Sign in</Link> first.
            </div>
          )}
        </div>

        <ArtShowRequest />

        {approved.length > 0 && (
          <section className="art-roster">
            <h2 className="music-roster-title">Featured artists*</h2>
            <div className="music-roster-grid">
              {approved.map((a) => (
                <article key={a.id} className="roster-card" data-testid={`art-card-${a.id}`}>
                  {a.hero_image_url && (
                    <div className="roster-cover">
                      <img src={a.hero_image_url} alt={a.display_name} />
                    </div>
                  )}
                  <div className="roster-body">
                    <div className="roster-name">{a.display_name}</div>
                    {a.tagline && <div className="roster-tag">{a.tagline}</div>}
                    <p className="roster-pitch">{a.pitch}</p>
                  </div>
                </article>
              ))}
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default Art;
